module.exports = __webpack_public_path__ + "img/ug511.e26bed42.png";